<script setup lang="ts">
import collapseMotion from 'ant-design-vue/lib/_util/collapseMotion';
</script>

<template>
  <Transition v-bind="collapseMotion('ant-motion-collapse', false)">
    <slot />
  </Transition>
</template>

<style lang="scss" scoped>
@use './HeightMotion.scss';
</style>
